import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { Menu } from 'piral';
import { Link, useMatch } from 'react-router-dom';
import { account } from '../adal';


// const mainListItems = [
//   { text: 'Home', icon: <HomeRoundedIcon /> },
//   { text: 'Analytics', icon: <AnalyticsRoundedIcon /> },
//   { text: 'Clients', icon: <PeopleRoundedIcon /> },
//   { text: 'Tasks', icon: <AssignmentRoundedIcon /> },
// ];

const secondaryListItems = [
  { text: 'Settings', icon: <SettingsRoundedIcon /> },
  // { text: 'About', icon: <InfoRoundedIcon /> },
  // { text: 'Feedback', icon: <HelpRoundedIcon /> },
];

function isAdmin() {
  const roles = account()?.idTokenClaims?.roles || [];
  return roles.includes('it-admin');
}


export default function MenuContent() {
      const match = useMatch({
        path: '/settings',
    });
  return (
    <Stack sx={{ flexGrow: 1, pt: 0, px: 1, pb: 1, justifyContent: 'space-between' }}>
      <Menu type="general" />
      <List dense>
        {isAdmin() && (
          <ListItem key={'setting-side-bar'}  disablePadding sx={{ display: 'block' }}>
            <ListItemButton component={Link} to="/settings"  selected={!!match}>
              <ListItemIcon><SettingsRoundedIcon /></ListItemIcon>
              <ListItemText primary={"Settings"} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Stack>
  );
}
